import { NgModule } from '@angular/core';

import { SharedModule } from "../shared/shared.module";
import { DespachosComponent } from './despachos.component';
import { SeguradorasModule } from "./seguradoras/seguradoras.module";
import { DespachosRoutingModule } from "./despachos-routing.module";
import { SegurosModule } from "./seguros/seguros.module";
import { ObrigacoesModule } from "./obrigacoes/obrigacoes.module";
import { LicenciamentosModule } from "./licenciamentos/licenciamentos.module";
import { DespachoObrigacoesMenuComponent } from "./shared/despacho-obrigacoes-menu/despacho-obrigacoes-menu.component";
import { DespachoConfiguracaoObrigacoesComponent } from "./configuracao/configuracao-obrigacoes/despacho-configuracao-obrigacoes.component";
import { DespachoService } from "./shared/despacho.service";
import { DespachoSegurosMenuComponent } from "./shared/despacho-seguros-menu/despacho-seguros-menu.component";

@NgModule({
    imports: [
        SharedModule,
        SeguradorasModule,
        SegurosModule,
        ObrigacoesModule,
        LicenciamentosModule,
        DespachosRoutingModule
    ],
    providers: [
        DespachoService
    ],
    declarations: [
        DespachosComponent,
        DespachoObrigacoesMenuComponent,
        DespachoSegurosMenuComponent,
        DespachoConfiguracaoObrigacoesComponent,
    ],
    exports: [
        DespachoObrigacoesMenuComponent,
        DespachoSegurosMenuComponent
    ]
})
export class DespachosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/despachos.module.ts
 **/